import { Injectable } from "@angular/core";
import { MyProgressChange } from "../interfaces/my-progress-change";
import { MenuChanges } from "../interfaces/menu-changes";
import { Observable, Subject, of } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable()
export class GlobalService {
  constructor(private http: HttpClient) {}

  private menuLoaded = new Subject<boolean>();
  menuLoadStatus = this.menuLoaded.asObservable();
  menuLoadChanged(isMenuExist) {
    this.menuLoaded.next(isMenuExist);
  }

  public isNavBarShow: boolean = false;
  public isSlideBarShow: boolean = false;
  public copyRightYear: string = new Date().getFullYear().toString();
  public companyName: string = "BSRM";
  public companyDomain: string = "bsrm.com";

  progressChange: MyProgressChange = { isLoadingProgressShow: false };
  toogleProgressbarShow() {
    this.progressChange.isLoadingProgressShow =
      !this.progressChange.isLoadingProgressShow;
  }
  showProgressbar() {
    setTimeout(() => {
      this.progressChange.isLoadingProgressShow = true;
    });
  }
  hideProgressbar() {
    setTimeout(() => {
      this.progressChange.isLoadingProgressShow = false;
    });
  }

  public progressColor: string = "primary";
  public progressState: string = "indeterminate";
  // public progressState: string ="buffer"
  public progressValue = 50;
  public bufferValue = 75;

  // private apiUrl: string = "http://192.168.103.4/ftapi/";
  // private hostUrl: string = "http://192.168.103.4/";
  // private apiUrl: string = "http://localhost/ftapi/";
  // private hostUrl: string = "http://localhost/";

  /////// test data
  // private apiUrl: string = "http://hrissub.bsrm.com/plcapi/bsrmapi/";
  // private hostUrl: string = "http://hrissub.bsrm.com/plcapi/";

  private uiHostUrl: string = "plc";

  ////local
  // private apiUrl: string = "http://localhost:6466/bsrmapi/";
  // private hostUrl: string = "http://localhost:6466/";
  // private uiUrl: string = "http://localhost:4022/#/";

  ////local iis
  // private apiUrl: string = "http://localhost:91/bsrmapi/";
  // private hostUrl: string = "http://localhost:91/";
  // private uiUrl: string = "http://localhost:4022/#/";

  //test for mobile
  // private apiUrl: string = "http://omrapi.bsrm.com/crm_test_api/bsrmapi/";
  // private hostUrl: string = "http://omrapi.bsrm.com/crm_test_api/";
  // private uiUrl: string = "http://omrapi.bsrm.com/crm_test_ui/#/";

  //prod
  private apiUrl: string = "http://crm-test.bsrm.com/bsrmapi/";
  private hostUrl: string = "http://crm-test.bsrm.com/";
  private uiUrl: string = "http://crm.bsrm.com/#/";

  // physical folder live = .14 server C:\inetpub\wwwroot\CRM_UI

  // private apiUrl: string = "http://sales.bsrm.com/crm_cloud_api/bsrmapi/";
  // private hostUrl: string = "http://sales.bsrm.com/crm_cloud_api/";
  // private uiUrl: string = "http://sales.bsrm.com/crm_cloud_ui/#/";

  // open with
  // node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng serve --open --port=4225

  // build with below
  // node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng build --configuration production --aot --build-optimizer
  // node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng build --prod --aot --build-optimizer --base-href /omrtestui/
  //node --max_old_space_size=8048 --openssl-legacy-provider ./node_modules/@angular/cli/bin/ng build --aot --build-optimizer --output-hashing=all

  //node --max_old_space_size=8048 --openssl-legacy-provider ./node_modules/@angular/cli/bin/ng serve --open --port=4235
  

  // private apiUrl: string = "http://hrissub.bsrm.com/crm_test_api/bsrmapi/";
  // private hostUrl: string = "http://hrissub.bsrm.com/crm_test_api/";
  // private uiUrl: string = "http://crm_test.bsrm.com/#/";

  public reportViewerUrl: string =
    this.hostUrl + "Reports/ReportViewer.aspx?key=";

  private tokenApi: string = "key";
  public regenTokenApi: string = "RegenerateToken";
  private grantType: string = "password";

  // public logKey : string ="LOG_KEY";
  public applicationListName: string = "APPLICATION_KEY";
  public profileListName: string = "PROFILES_KEY";

  public menuKey: string = "MENU_KEY";
  public selectedResponsibilityKey: string = "SELECTED_RESPONSIBILITY_KEY";

  public selectedPLCORACLEResponsibilityKey =
    "SELECTED_PLC_ORACLE_RESPONSIBILITY_KEY";

  private httpResultData: any;
  public userNameTitle: string = "UserName";
  public userIdTitle: string = "UserId";

  public selectedApplicationId: string;
  public selectedApplicationName: string;

  //region pagination data
  length = 100;
  pageSize = 10;
  pageSizeOptions = [2, 5, 10, 15, 20, 25, 50, 100];
  //endregion

  //region COMPANY DETAILS
  public getCompanyName(): string {
    return this.companyName;
  }
  public getCompanyDomain(): string {
    return this.companyDomain;
  }
  public getNotFoundError(): string {
    return (
      "The page are you looking for is not available right now. Please contact with " +
      this.companyName +
      ", IT Department."
    );
  }
  //endregion

  //region URL DETAILS
  public getHostUrl(): string {
    return this.hostUrl;
  }
  public getApiUrl(): string {
    return this.apiUrl;
  }
  public getTokenUrl(): string {
    return this.hostUrl + this.tokenApi;
  }
  // public getRegenTokenUrl(): string{
  //   return this.hostUrl+this.regenTokenApi;
  // }
  public getGrantType(): string {
    return this.grantType;
  }
  //endregion

  //region aips api list
  public promotionApi: string = "ProFor";
  //endregion

  //region api list
  public applicationApi: string = "Application";
  public menuApi: string = "Menu";
  public departmentApi: string = "Department";
  public safetyApi: string = "Safety";
  public chemistryApi: string = "Chemistry";
  public profileImageApi: string = "ProfileImage";
  public attachmentApi: string = this.getApiUrl() + "Attachment";
  //endregion

  //region application list
  public ApplicationList;
  //endregion

  public redirectApi = "Redirect";
  public resetPasswordApi = "ResetPassword";

  //region  menu list

  menuChanges: MenuChanges = { menus: [] };
  public setMenu(_menus) {
    this.menuChanges.menus = _menus;
  }
  public MenuKey: string;
  //endregion

  GetMenus(completeUrl: string) {
    var menuList = sessionStorage.getItem(this.applicationListName);
    return menuList;
  }

  GetMenuPermissionDetails(completeUrl: string) {
    var menus = JSON.parse(sessionStorage.getItem(this.applicationListName));
    var menuDetails = {
      CanView: false,
      CanInsert: false,
      CanEdit: false,
      CanDelete: false,
    };

    // console.log('url in global service' +completeUrl);
    var rt = completeUrl.split("/");
    console.log(rt);
    if (rt.length >= 4) {
      var firstSegment = rt[1];
      var secondSegment = rt[2];
      var thirdSegment = rt[3];
    }
    console.log(firstSegment);
    console.log(secondSegment);
    console.log(thirdSegment);
    console.log(menus);
    var allMenus = [];
    var selectedMenu;

    console.log("menus");
    console.log(menus);
    menus.forEach((element) => {
      console.log(element);
      element.items.forEach((mg) => {
        console.log(mg);
        mg.items.forEach((m) => {
          console.log(m);
          allMenus.push(m);
        });
      });
    });

    console.log(allMenus);
    selectedMenu = allMenus.find(
      (s) =>
        s.AppRouteName == firstSegment &&
        s.MenuGroupRouteName == secondSegment &&
        s.MenuRouteName == thirdSegment
    );
    console.log("selected menu");
    console.log(selectedMenu);

    if (selectedMenu) {
      menuDetails.CanView = selectedMenu.CANVIEW;
      menuDetails.CanInsert = selectedMenu.CANINSERT;
      menuDetails.CanEdit = selectedMenu.CANUPDATE;
      menuDetails.CanDelete = selectedMenu.CANDELETE;
    }
    console.log("menuDetails");
    console.log(menuDetails);
    return menuDetails;
  }
  //endregion

  public salesOrderApi: string = "SalesOrder";
  public customerVrsApi: string = "CustomerVrs";
  public dateApi: string = "NewDate";
  public apnarJiggashaApi: string = "ApnarJiggasha";
  public reportApi: string = "Reports";

  public searchSOApi: string = "SearchSO";
  public searchVRSOApi: string = "SearchVRSO";
  public searchVRSApi: string = "SearchVRS";

  public searchApi: string = "Search";

  pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
  public formateDateCRM(d: Date): string {
    var day = d.getDate();
    var mon = d.getMonth();
    var year = d.getFullYear();
    var hour = d.getHours();

    var ampm = hour > 11 ? "pm" : "am";
    hour = hour > 11 ? hour - 12 : hour;
    var min = d.getMinutes();
    var sec = d.getSeconds();
    var monthName: string = this.findMonthName(mon);
    var newDate =
      this.pad(day, 2) +
      "-" +
      monthName +
      "-" +
      year +
      "-" +
      this.pad(hour, 2) +
      "-" +
      this.pad(min, 2) +
      "-" +
      this.pad(sec, 2) +
      "-" +
      ampm;

    return newDate;
  }
  public findMonthName(monthNumber: number) {
    var monthName: string;
    switch (monthNumber) {
      case 0:
        monthName = "Jan";
        break;
      case 1:
        monthName = "Feb";
        break;
      case 2:
        monthName = "Mar";
        break;
      case 3:
        monthName = "Apr";
        break;
      case 4:
        monthName = "May";
        break;
      case 5:
        monthName = "Jun";
        break;
      case 6:
        monthName = "Jul";
        break;
      case 7:
        monthName = "Aug";
        break;
      case 8:
        monthName = "Sep";
        break;
      case 9:
        monthName = "Oct";
        break;
      case 10:
        monthName = "Nov";
        break;
      case 11:
        monthName = "Dec";
        break;
      default:
        monthName = "N/A";
    }
    return monthName;
  }

  public getSOFormatDate(dateObj) {
    if (dateObj instanceof Date) {
      var WODt = dateObj;

      // console.log(WODt.toLocaleString("default", { month: "short" }));

      var dateString = WODt.getDate().toString();
      var monthString = (WODt.getMonth() + 1).toString();

      var date = (dateString.length == 1 ? "0" : "") + dateString;
      date += "-";
      date += (monthString.length == 1 ? "0" : "") + monthString;
      date += "-";
      date += WODt.getFullYear().toString();

      return date;
    }
    return "";
  }

  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  public getOracleFormatDate(dateObj) {
    if (dateObj instanceof Date) {
      var WODt = dateObj;

      console.log(WODt.toLocaleString("default", { month: "short" }));

      var dateString = WODt.getDate().toString();
      var monthString = (WODt.getMonth() + 1).toString();

      var date = (dateString.length == 1 ? "0" : "") + dateString;
      date += "-";
      // date += WODt.toLocaleString("default", { month: "short" });
      date += this.monthNames[WODt.getMonth()]; //WODt.toLocaleString("default", { month: "short" });
      date += "-";
      date += WODt.getFullYear().toString();

      return date;
    }
    return "";
  }

  successMsg: string = "";
  errorMsg: string = "";
  isShowPopup: boolean = false;
  closePopup() {
    this.isShowPopup = false;
  }
  showError(message: string) {
    this.errorMsg = "<i class='glyphicon glyphicon-alert'></i>" + message;
    this.successMsg = "";
    this.isShowPopup = true;
  }
  showSuccess(message: string) {
    this.errorMsg = "";
    this.successMsg = message;
    this.isShowPopup = true;
  }
  popupHidding(e) {}

  getOrderDetails(): Observable<any[]> {
    //
    let grnId = JSON.parse(localStorage.getItem("orderNos")) as [];
    // console.log(grnId);

    const orderNos = grnId.map((x: any) => x.orderNo).join(",");

    let params = new HttpParams();
    params = params.append(`orderNo`, orderNos);

    // grnId.forEach((grnNo: any) => {
    //   params = params.append(`orderNo`, grnNo.orderNo);
    // });

    // console.log(params);
    //return of(null);
    this.showProgressbar();
    return this.http
      .get<any[]>(this.apiUrl + "OrderDetail", { params: params })
      .pipe(
        map((grns) => {
          this.hideProgressbar();
          //console.log(JSON.parse(JSON.stringify(grns)));
          return grns as [];
        })
      );
  }

  getVRSDetails(id: string): Observable<any> {
    return this.http.get(this.apiUrl + "CustomerVrs/" + id);
  }
}
